import { render } from "./GameImageSpotter.vue?vue&type=template&id=6cfc683d&scoped=true"
import script from "./GameImageSpotter.vue?vue&type=script&lang=js"
export * from "./GameImageSpotter.vue?vue&type=script&lang=js"

import "./GameImageSpotter.vue?vue&type=style&index=0&id=6cfc683d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cfc683d"],['__file',"src/vue/components/GameImageSpotter.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6cfc683d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6cfc683d', __exports__)) {
    api.reload('6cfc683d', __exports__)
  }
  
  module.hot.accept("./GameImageSpotter.vue?vue&type=template&id=6cfc683d&scoped=true", () => {
    api.rerender('6cfc683d', render)
  })

}


export default __exports__